import React from 'react';
import ReactDOM from 'react-dom/client';

//import 'bootstrap/dist/css/bootstrap.css'; //. x

import 'semantic-ui-css/semantic.min.css'; //' x
import 'react-calendar/dist/Calendar.css'; //'
import 'react-toastify/dist/ReactToastify.min.css'; //' add this manally
import 'react-datepicker/dist/react-datepicker.css'; //'

//import './index.css'; //' -->
import './app/layout/styles.css'; //'

import App from './app/layout/App';
import reportWebVitals from './reportWebVitals';
import { store, StoreContext } from './app/stores/store'; //'
import { RouterProvider } from 'react-router-dom'; //'
import { router } from './app/router/Routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// root.render(
//   // <React.StrictMode> //'
//     <App />
//   // </React.StrictMode> //'
// );

root.render( //'
  // <React.StrictMode> //'
  <StoreContext.Provider value={store}>
    {/* <App /> */}
    <RouterProvider router={router} /> {/* React Router  */}
  </StoreContext.Provider>
  // </React.StrictMode> //'
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
